import React from 'react'
import View from '../modules/common/View'

export default () => <View name='home' scrolltop={true} />
